import { type EntityState } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

import { type CanvasElement } from '@blaze-runtime/engine-domain';

export const TAG = '[Elements Internal]';

/** Do not use directly! - Actions for use from services automating elements operations */

/** Update the state with the new element placed inside */
const placeNewElement = createAction(
  `${TAG} Place new element`,
  props<{ entityState: EntityState<CanvasElement> }>(),
);

export const elementsInternal = {
  placeNewElement,
};
